import React from "react";

import DefaultLayout from "../layouts/DefaultLayout";
import { I18nProvider } from "../utils/localization/languages/I18nContext";
import { getCurrentGeolocation } from "../utils/localization/geolocation/geolocationLoader";
import { sendPageAnalytics } from "../utils/analytics";
import { isSSR } from "../utils/ssr";
import { AuthProvider } from "features/auth/AuthProvider";

//import Modal from "react-modal";
import { SitePageContext } from "types/graphql-types";
import { LanguageCode } from "../utils/localization/languages/types";
import { languageFromCode } from "../utils/localization/languages/languages";
import { UserIdProvider } from "src/utils/UserIdProvider";
import { SnackbarProvider } from "@silversea-ssc/system-components-react/SnackbarProvider";

import { SfoModalProvider } from "components/SfoModal/SfoModalProvider";

let analyticsSent = false; // for some reasons the wrapPageElement is called multiple times in some pages and we send more than once the analytics event. This variable tries to prevent that.

export const wrapPageElement = ({ element, props }) => {
  const pageContext = props.pageContext as SitePageContext;
  const { modal = false } = pageContext;
  const language = languageFromCode(pageContext.languageCode as LanguageCode);
  const trackingParams = pageContext.trackingParams;
  const isBrowser = typeof window !== "undefined";

  if (Object.keys(pageContext).length == 0) {
    //"/dev-404-page/"
    return (
      <React.Fragment>
        <I18nProvider language={language}>
          <SfoModalProvider key={props.location.pathname}>
            {element}
          </SfoModalProvider>
        </I18nProvider>
      </React.Fragment>
    );
  }

  if (modal)
    return (
      <React.Fragment>
        <I18nProvider language={language}>
          <SfoModalProvider key={props.location.pathname}>
            {element}
          </SfoModalProvider>
        </I18nProvider>
      </React.Fragment>
    );

  if (!isSSR()) {
    let geo_country_code = "Failed";
    let geo_market = "Failed";
    // Mirrors GeolocationContext, which keeps USD when the API fails
    let currency = "USD";

    getCurrentGeolocation()
      .then(({ detectedCountryCode, market, defaultCurrency }) => {
        geo_country_code = detectedCountryCode || "Failed";
        geo_market = market || "Failed";
        currency = defaultCurrency || "USD";
      })
      .catch((e) => {
        if (window.rollbar) window.rollbar.error(e);
        geo_country_code = "Failed";
        geo_market = "Failed";
      })
      // we want to trigger page view even if the geolocation API failed
      .finally(() => {
        if (analyticsSent) return;
        sendPageAnalytics({
          pageCategory1: trackingParams?.pageCategory1 || "Unavailable",
          pageCategory2: trackingParams?.pageCategory2 || "Unavailable",
          pageType: trackingParams?.pageType || "Unavailable",
          language: language.ogLang || "Unavailable",
          countryCode: geo_country_code || "Unavailable",
          market: geo_market || "Unavailable",
          currency
        });
        analyticsSent = true;
      });
  }
  const innerContent = (
    <SfoModalProvider key={props.location.pathname}>
      <DefaultLayout {...props}>{element}</DefaultLayout>
    </SfoModalProvider>
  );

  return (
    <UserIdProvider>
      <I18nProvider language={language}>
        <SnackbarProvider>
          {isBrowser ? (
            <AuthProvider>{innerContent}</AuthProvider>
          ) : (
            innerContent
          )}
        </SnackbarProvider>
      </I18nProvider>
    </UserIdProvider>
  );
};
